import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    StoriesCreateStoryResponseT,
    StoriesCreateStorySlideResponseT,
    StoriesGetListResponseT,
    StoriesGetStoryResponseT,
    StoriesGetStorySlidesResponseT,
    StoryPayloadT,
} from '../types/stories.types'

export class StoriesRepository {
    getList(page: number): Promise<AxiosResponse<StoriesGetListResponseT>> {
        const params = {
            page,
        }

        return http.get('/cabinet/api/stories', { params })
    }

    getStory(story_id: number): Promise<AxiosResponse<StoriesGetStoryResponseT>> {
        return http.get(`/cabinet/api/stories/${story_id}`)
    }

    createStory(story_payload: StoryPayloadT): Promise<AxiosResponse<StoriesCreateStoryResponseT>> {
        return http.post('/cabinet/api/stories', story_payload)
    }

    updateStory(
        story_id: number,
        payload: StoryPayloadT
    ): Promise<AxiosResponse<StoriesCreateStoryResponseT>> {
        return http.post(`/cabinet/api/stories/${story_id}/update`, payload)
    }

    publishStory(story_id: number): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/stories/${story_id}/publish`, null)
    }

    unpublishStory(story_id: number): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/stories/${story_id}/unpublish`, null)
    }

    deleteStory(story_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/stories/${story_id}`)
    }

    getStorySlides(story_id: number): Promise<AxiosResponse<StoriesGetStorySlidesResponseT>> {
        return http.get(`/cabinet/api/stories/${story_id}/items`)
    }

    createStorySlide(
        story_id: number,
        payload: FormData
    ): Promise<AxiosResponse<StoriesCreateStorySlideResponseT>> {
        return http.post(`/cabinet/api/stories/${story_id}/item/create`, payload)
    }

    updateStorySlide(
        slide_id: number,
        payload: FormData
    ): Promise<AxiosResponse<StoriesCreateStorySlideResponseT>> {
        return http.post(`/cabinet/api/stories/item/${slide_id}/update`, payload)
    }

    deleteStorySlide(slide_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/stories/item/${slide_id}`)
    }
}
